// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { Pais } from "../../../interfaces/Pais";
import { paisService } from "../../../services/paisService";

export const usePaises = (fetch: boolean) => {
  const [isLoading, setIsLoading] = useState(true);
  const [paises, setPaises] = useState<Pais[]>([]);

  useEffect(() => {
    const fetchEstado = async () => {
      if (fetch) {
        setIsLoading(true);
        try {
          const data = await paisService();
          if (data) {
            setPaises(data);
          } else {
            console.error("Não foi possível encontrar países");
          }
        } catch (error) {
          console.error("Erro ao buscar países:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchEstado();
  }, [fetch]); // Dependência de aptoId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, paises };
};
